import React, { useState, useRef, useEffect, forwardRef, useImperativeHandle} from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Input,
  Button,
  Space,
  message,
  Radio,
  ConfigProvider
} from "antd";
import { HomeOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import { FileDetail, CustomUpload, CustomUploadNew1 } from "@/hocComponents";
import commonFn from "@/utils/commonFn";

const MPAPModal = forwardRef(({MPAPMConfig}, ref) => {
    const {contractId, projectId, propId, id, submitInitFn, editUrl} = MPAPMConfig
    const [form] = Form.useForm();
    const [type, setType] = useState('add');
    const [statusId, setStatusId] = useState(null);
    const [colorStr, setColorStr] = useState('#3c8dbc');
    const [modalName, setModalName] = useState('Payment Request');
    const [modalFlag, setModalFlag] = useState(false);
    const [stepBackBtnLoading, setStepBackBtnLoading] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [filePaths, setFilePaths] = useState([]);
    const [vendorList, setVendorList] = useState([]);
    const [vendorOption, setVendorOption] = useState({});
    const [detail, setDetail] = useState(null);
    const [recordTypetKey, setRecordTypetKey] = useState(0);
    const customUploadNewRef = useRef(null);
    
    useImperativeHandle(ref, () => ({
      openModal: ({type, modalName, statusId, colorStr}) => {
        initFn()
        setType(type)
        setModalName(modalName)
        if(statusId){
          setStatusId(statusId)
        }
        if(type === 'view' && colorStr){
          setColorStr(colorStr)
        }
        setModalFlag(true)
      }
    }));

    const initFn = () => {
      setStatusId(null)
      setColorStr('#3c8dbc')
      setDetail(null)
      setGlAcctList([])
      setVendorList([])
      setVendorOption({})
      form.resetFields();
      setFilePaths([])
      setStepBackBtnLoading(false)
      setBtnLoading(false)
      setBtnDisabled(false)
    }

    const afterOpenChangeFn = (flag) => {
      if(flag){
        glAcctFun()
        if(type !== 'add'){
          setRefuseReasonFlag(false)
          getDetailFn()
        }else{
          getVendorList()
        }
      }else{
        initFn()
      }
    }
    const [glacctList, setGlAcctList] = useState([]);

    const glAcctFun = async () => {
      const response = await http.get(api.showGlAcctByChartNameId,  { params: {propId, acctType: ["E"].toString(), active: 1} });
      if (response?.code === "1") {
        setGlAcctList((response.data || [])?.map((item) => ({
          value: item.glAcct,
          label: item.glAcctTitle,
          title: item.title,
        })));
      } else {
        commonFn.modalFailedFn(response)
      }
    };

    const selcetChangeFn = async (option = {}, key) => {
      setVendorOption(option);
      form.setFieldsValue({ ['recordVendorId']: option[key] });
    };

    const getVendorList = async (content = '') => {
      const response = await http.get(api.vendorSearch, {params: {content}});
      if (response?.code === "1") {
        const list = (response.data || []).map((item) => ({
          value: item.vendid,
          label: item.vendorName,
          vendorId: item.vendorId,
        }));
        setVendorList(list);
        return list
      }
      return []
    };

    const getDetailFn = async() => {
      if(['send', 'edit', 'onlyNew'].includes(type) && customUploadNewRef.current){
        customUploadNewRef.current.initIsLoading(true)
      }
      setBtnDisabled(true)
      const response = await http.get(api.getRecordDetail, { params: {id: statusId || id} });
      if (response?.code === "1") {
        const { recordType, recordVendorName, id, recordVendorId, rstatus, addressCity, stateZip } = response.data
        setDetail({
          showVendorNameFlag: id && !recordVendorId,
          ...response.data
        })

        const vendorListTemp = await getVendorList(recordType === 1 ? '' : recordVendorName)
        let option = vendorListTemp
        if(recordType === 2 && recordVendorId){
          option = vendorListTemp.find(item => item?.vendorId === recordVendorId)
        }
        selcetChangeFn(option, '')
        form.setFieldsValue({
          ...response.data,
          status: rstatus,
          addressCityStateZip: [addressCity, stateZip].filter(Boolean).join('\n'),
        });
        if(['send', 'edit', 'onlyNew'].includes(type) && customUploadNewRef.current){
          const list = (response.data?.fileList || [])?.map(item => ({ ...item, url: item.allPath, baseUrl: item.allPath, name: item.name || item.fileName, type: item.contentType}))
          customUploadNewRef.current.initUpdateList(list)
        }
        setRefuseReasonFlag(rstatus === 4)
      }
      setBtnDisabled(false)
    }

    const testFn = async () => {
      console.log("====detail", detail);
    }

    const formItemFn = ({
      name,
      label,
    }) => {
      if(type !== 'view') return null
      return (
        <Form.Item
          name={name}
          label={label}
        >
          <Input
            disabled={true}
          />
        </Form.Item>
      )
    }

    const [refuseReasonFlag, setRefuseReasonFlag] = useState(false);

    const approvalTypeChangeFn = (e) => {
      if (e.target.value === 201) {
        form.setFieldValue('refuseReason', '')
        setRefuseReasonFlag(false)
      }else{
        setRefuseReasonFlag(true)
      }
    }

    const submitAddFn = async() => {
      setBtnLoading(true)
      const { recordType, recordVendorId } = form.getFieldValue()
      const response = await http.post(api.saveContractRecord, {
        record: {
          ...form.getFieldValue(),
          recordVendorId: recordType === 1 ? undefined : recordVendorId,
          status: 9,
          contractId,
          projectId
        },
        fileList: filePaths
      });
      if (response.code === "1") {
        message.success("New successfully");
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitStatusFn = async() => {
      setBtnLoading(true)
      const {status, refuseReason, recordType, recordVendorId} = form.getFieldValue()
      const response = await http.post(api.approveContractRecord, {
        record: {
          ...form.getFieldValue(),
          recordVendorId: recordType === 1 ? undefined : recordVendorId,
          id,
          status: detail.status === 9 ? 201 : status,
          refuseReason,
        },
        fileList: filePaths.filter(item => !item.id)
      });
      if (response.code === "1") {
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitEditFn = async(flag) => {
      let params
      if(flag){
        setStepBackBtnLoading(true)
        params = {
          record: {
            status: 202,
            id,
          }
        }
      }else{
        setBtnLoading(true)
        const { recordType, recordVendorId } = form.getFieldValue()
        params = {
          record: {
            ...form.getFieldValue(),
            recordVendorId: recordType === 1 ? undefined : recordVendorId,
            status: editUrl ? undefined : 9,
            id,
          },
          fileList: filePaths.filter(item => !item.id)
        }
      }
      const response = await http.post(editUrl || api.updateRecordContract, params);
      if (response.code === "1") {
        message.success(`${ flag ? "Step Back" :"Updated"} successfully`);
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      if(flag){
        setStepBackBtnLoading(false)
      } else {
        setBtnLoading(false)
      }
    }

    const submitStatusFileFn = async() => {
      setBtnLoading(true)
      const response = await http.post(api.contractUploadFileForVendorPayment, {
        id,
        fileList: filePaths.filter(item => !item.id)
      });
      if (response.code === "1") {
        setModalFlag(false)
        submitInitFn();
      } else {
        commonFn.modalFailedFn(response)
      }
      setBtnLoading(false)
    }

    const submitFn = async(flag) => {
      form.validateFields().then(value => {
        if(type === 'add'){
          submitAddFn()
        }else if(type === 'send'){
          submitStatusFn()
        }else if(type === 'edit'){
          submitEditFn(flag)
        }else if(type === 'onlyNew'){
          submitStatusFileFn()
        }
      }).catch(err =>{
        console.log(err,'===err');
      })
    }

    const deleteOldFn = async(file) => {
      let flag = false
      const response = await http.get(api.delContractFile, { params: {id: file.id, isDeleteInvoice: type === 'onlyNew' } });
      if (response.code === "1") {
        flag = true
      }
      return flag
    }

  return (
    <Modal
      title={
        <div style={{ fontSize: "24px", fontWeight: "bold", color: colorStr || "#3c8dbc" }}>
          <HomeOutlined style={{ marginRight: "8px" }} />
          {modalName}
          <div
            style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
          ></div>
        </div>
      }
      centered
      open={modalFlag}
      onCancel={() => setModalFlag(false)}
      footer={null}
      maskClosable={false}
      afterOpenChange={afterOpenChangeFn}
      width="80%"
    >
      <Form
        form={form}
        layout="horizontal"
        labelCol={{span: 8}}
        wrapperCol={{span: 16}}
        labelWrap={true}
        labelAlign="right"
        validateMessages={{
          required: "${label} is required!",
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Payment Request
            </div>
            
            <Form.Item
              name="addressCityStateZip"
              label="Prop - Address, City State Zip"
            >
              <Input.TextArea
                disabled
                placeholder=""
              />
            </Form.Item>

            {colorStr === 'green' && (
              formItemFn({
                  name: 'clearDate',
                  label: 'Clear Date'
                })
              ) || null
            }
            {(colorStr === 'green' || colorStr === '#dd4b39') && (
              <>
                {formItemFn({
                  name: 'checkNo',
                  label: 'Check #'
                })}
                {formItemFn({
                  name: 'checkDate',
                  label: 'Check Date'
                })}
              </>
              ) || null
            }
            <ConfigProvider componentDisabled={['view', 'onlyNew'].includes(type)}>

              {commonFn.formInputNumberDoc({
                form,
                label: "Amount",
                disabled: ['view', 'onlyNew'].includes(type),
                allowNegative: false
              })}

              <Form.Item
                name="invoiceNumber"
                label="Invoice #"
                rules={[{ required: true, message: 'Invoice # is required!' }]}
              >
                <Input
                  placeholder="Please input Invoice #"
                />
              </Form.Item>

              <Form.Item
                name="glAcct"
                label="Expense GL Account"
                rules={[{ required: true, message: 'Expense GL Account is required!' }]}
              >
                <Select
                  showSearch
                  placeholder="Select a type"
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={glacctList}
                />
              </Form.Item>

              <Form.Item
                name="recordType"
                label="Payment Type"
                rules={[{ required: true, message: 'Payment Type is required!' }]}
              >
                <Select
                  showSearch
                  placeholder="Select a type"
                  onChange={(e) => setRecordTypetKey(+new Date())}
                  optionFilterProp="label"
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      label: 'Major Project',
                      value: 1
                    },
                    {
                      label: 'Other Payment',
                      value: 2
                    }
                  ]}
                />
              </Form.Item>
              {form.getFieldValue().recordType === 2 && (
                <>
                  <Form.Item
                    style={{marginBottom: detail?.showVendorNameFlag ? 0 : 24}}
                    name="recordVendorId"
                    label="Contractor"
                    rules={[{ required: !refuseReasonFlag, message: 'Contractor is required!' }]}
                  >
                    <Select
                      allowClear
                      showSearch
                      placeholder="Select a type"
                      onChange={(value, option) => selcetChangeFn(option, 'vendorId')}
                      onSearch={(value) => {getVendorList(value)}}
                      optionLabelProp={{ label: "value" }}
                      value={vendorOption?.value}
                      filterOption={(input, option) =>
                        (option?.label ?? "")?.toLowerCase().includes(input.toLowerCase())
                      }
                      options={vendorList}
                    />
                    <div>{vendorOption?.label || ''}</div>
                  </Form.Item>
                  {detail?.showVendorNameFlag && <Form.Item
                    name=""
                    style={{marginBottom: 12}}
                    label={null}
                  >
                    <div>{detail?.recordVendorName || ''}</div>
                  </Form.Item> || null}
                </>
              ) || null}

              <Form.Item
                name="remark"
                label="Remark"
              >
                <Input.TextArea
                  placeholder="Please input Remark"
                  autoSize={{ minRows: 3, maxRows: 10 }}
                />
              </Form.Item>
            </ConfigProvider>
            {(colorStr === 'green' || colorStr === '#dd4b39') && (
                formItemFn({
                  name: 'checkPrintBy',
                  label: 'Check Printed By'
                })
              ) || null
            }

            {colorStr === '#3c8dbc' && (
              <>
                {formItemFn({
                  name: 'requestCreatedBy',
                  label: 'Request Created By'
                })}
                {formItemFn({
                  name: 'requestCreatedDate',
                  label: 'Request Created Date'
                })}
              </>
              ) || null
            }

            {formItemFn({
              name: 'requestSendBy',
              label: 'Sent By'
            })}
  
            {(((['view', 'edit', 'onlyNew'].includes(type)) && detail?.rstatus) || (type === 'send' && [2, 202].includes(detail?.status))) && (
              <>
                <Form.Item
                  name="status"
                  label="Select"
                  rules={[{ required: true, message: "Please select an option!" }]}
                  validateTrigger="onChange"
                >
                  <Radio.Group  onChange={approvalTypeChangeFn} disabled={type !== 'send' || btnDisabled}>
                    <Radio value={201}>Agree</Radio>
                    <Radio value={4}>Refuse</Radio>
                  </Radio.Group>
                </Form.Item>
                {refuseReasonFlag && (
                  <Form.Item
                    label="Refuse Reason"
                    name="refuseReason" // 必须添加 name 属性
                  >
                    <Input.TextArea
                      disabled={type !== 'send'}
                      autoSize={{ minRows: 3, maxRows: 10 }}
                    />
                  </Form.Item>
                )}
              </>
            )}
          </Col>
          <Col span={16}>
            <div
              style={{
                marginBottom: "16px",
                fontWeight: "bold",
                fontSize: "20px",
              }}
            >
              <HomeOutlined style={{ marginRight: "8px" }} />
              Upload Invoice, Photo
            </div>

            <Form.Item labelCol={{ span: 0 }} wrapperCol={{ span: 24 }} name="uploadFile" label={null}>
              {['add', 'send', 'edit', 'onlyNew'].includes(type) ? (
                <CustomUploadNew1
                  ref={customUploadNewRef}
                  customConfig={{
                    pdfHeight: "76vh",
                    accept: ".jpg, .jpeg, .png, .pdf",
                    status: 'add',
                    deleteOldFn: deleteOldFn
                  }}
                  setFilePaths={setFilePaths} 
                  filePaths={filePaths} 
                  setBtnDisabled={setBtnDisabled}
                  btnDisabled={btnDisabled}
                />
              ) : (
                detail?.createType === 3 ? (
                  <CustomUpload 
                    setFilePaths={setFilePaths} 
                    filePaths={filePaths} 
                    setBtnDisabled={setBtnDisabled}
                    btnDisabled={btnDisabled}
                    isEdit={true}
                    vendorPaymentId={detail?.vendorPaymentId || undefined}
                    type={'approval'}
                    customConfig={{
                      accept: ".jpg, .jpeg, .png, .pdf",
                      noShowUpload: true,
                      noSubmitBtn: true,
                      disabled: false
                    }}
                  />
                ) : (
                  <FileDetail
                    urlKey="allPath"
                    fileList={detail?.fileList || []}
                  />
                )
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Space align="center">
          {/* <Button key="back" onClick={testFn}>
            TEST
          </Button> */}
          {commonFn.btnAuthorityFlag('stepBack') && type === 'edit' && detail?.createType === 2 && <Button type="primary" danger onClick={() => submitFn(true)} loading={stepBackBtnLoading} disabled={btnDisabled || btnLoading}>
            Step Back
          </Button> || null}
          <Button key="back" onClick={() => setModalFlag(false)}>
            Cancel
          </Button>
          {
            type !== 'view' && (
              <Button type="primary" onClick={() => submitFn()} loading={btnLoading} disabled={btnDisabled || stepBackBtnLoading}>
                Submit
              </Button>
            ) || null
          }
        </Space>
      </div>
    </Modal>
  );
});

export default MPAPModal;